import { render } from "./SentinelOriana.vue?vue&type=template&id=6f01f4f0"
import script from "./SentinelOriana.vue?vue&type=script&lang=js"
export * from "./SentinelOriana.vue?vue&type=script&lang=js"

import "./SentinelOriana.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__